import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { UserDataFirebaseResponse } from '../../types';
import { GetUserApiResponse, USERS_QUERY_KEY } from './types';

// Pojedynczy użytkownik panelu (v3-getUser) — widoki User/EditUser/Profile oraz
// „account manager" w Organizacjach. Zastępuje odczyt `users/{id}` client-side.
export const useGetUser = (
  uid: string | null | undefined,
  options?: UseQueryOptions<UserDataFirebaseResponse | null, AxiosError>,
): UseQueryResult<UserDataFirebaseResponse | null, AxiosError> => useQuery<
  UserDataFirebaseResponse | null,
  AxiosError
>({
  queryKey: [USERS_QUERY_KEY, 'single', uid] as const,
  queryFn: async (): Promise<UserDataFirebaseResponse | null> => {
    const res = await axiosInstance.get<GetUserApiResponse<UserDataFirebaseResponse>>(
      '/v3-getUser',
      { params: { uid } },
    );
    return res.data.data.user ?? null;
  },
  enabled: !!uid,
  retry: 0,
  ...options,
});
